<template>
  <div class="md-layout">
    <div>
      <date-range-picker
        :start="filters.travel_from"
        :end="filters.travel_to"
        :display-list="false"
        :min-days="2"
        :max-days="maxDays"
        :max-months="3"
        :display-from-to="true"
        @change="changeTravelDate"
      />
    </div>
    from {{ filters.travel_from }} - to {{ filters.travel_to }}
  </div>
</template>

<script>
import DateRangePicker from '@/components/Inputs/DateRangePicker'

export default {
  components: {
    DateRangePicker,
  },
  data() {
    return {
      maxDays: 15,
      filters: {
        travel_from: this.moment()
          .toDate()
          .toString(),
        travel_to: this.moment()
          .toDate()
          .toString(),
      },
    }
  },
  methods: {
    changeTravelDate(range) {
      this.filters.travel_from = range.start
      this.filters.travel_to = range.end
    },
  },
}
</script>

<style lang="scss"></style>
